import React, { FC } from 'react';

interface Props {
  className?: string;
  size: number;
}
export const CaroIcon: FC<Props> = ({ className, size }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="36" height="36" rx="4" fill="#ECEFF3" />
      <path
        d="M8 34.3928C8 30.3099 11.3099 27 15.3928 27H20.6072C24.6901 27 28 30.3099 28 34.3928V36H8V34.3928Z"
        fill="#116DFF"
      />
      <path d="M2 13C2 11.3431 3.34315 10 5 10H6V20H5C3.34315 20 2 18.6569 2 17V13Z" fill="#192C55" />
      <path d="M34 13C34 11.3431 32.6569 10 31 10H30V20H31C32.6569 20 34 18.6569 34 17V13Z" fill="#192C55" />
      <rect x="5" y="6" width="26" height="18" rx="6" fill="#116DFF" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25504 10.7355C10.0613 8.58339 13.1525 8.40892 15.1594 10.3459C16.7743 11.9044 19.2257 11.9044 20.8406 10.3459C22.8475 8.40892 25.9387 8.58339 27.745 10.7355C29.5512 12.8877 29.3885 16.2025 27.3816 18.1395C22.0482 23.2868 13.9518 23.2868 8.61843 18.1395C6.6115 16.2025 6.44881 12.8877 8.25504 10.7355Z"
        fill="white"
      />
      <path
        d="M24 16C25.1046 16 26 15.1046 26 14C26 12.8954 25.1046 12 24 12C22.8954 12 22 12.8954 22 14C22 15.1046 22.8954 16 24 16Z"
        fill="#192C55"
      />
      <path
        d="M12 16C13.1046 16 14 15.1046 14 14C14 12.8954 13.1046 12 12 12C10.8954 12 10 12.8954 10 14C10 15.1046 10.8954 16 12 16Z"
        fill="#192C55"
      />
      <path
        d="M15 18V18C16.8167 19.2111 19.1833 19.2111 21 18V18"
        stroke="#192C55"
        stroke-width="1.5"
        stroke-linecap="square"
      />
      <path
        d="M13.1778 4.60139L12 6L14.0563 7.62792C15.1788 8.51652 16.5684 9 18 9C19.4316 9 20.8212 8.51652 21.9437 7.62792L24 6L22.8222 4.60139C21.9672 3.58605 20.7075 3 19.3801 3H16.6199C15.2925 3 14.0328 3.58605 13.1778 4.60139Z"
        fill="#192C55"
      />
      <path d="M15 24H21V28C21 29.6569 19.6569 31 18 31C16.3431 31 15 29.6569 15 28V24Z" fill="#192C55" />
    </svg>
  );
};
